
import { useEffect, useState } from "react";

import { Outlet } from "react-router";

import { ViewContext } from "../state/view";

import { Footer } from "./footer";

import { Header } from "./header";

import { Hero } from "./hero";

import { Disclaimer } from "../components/disclaimer";

import { Share } from "../app/features/share/page";

export function Layout() {

  const [ view, setView ] = useState( () => {

    const storedView = localStorage.getItem( 'view' );

    return storedView ? Number( storedView ) : 1;
    
  } );

  const answers = JSON.parse( localStorage.getItem( 'answers' ) );
  
  const answeredAllQuestions = answers?.every( answer => answer.answers );

  useEffect( () => {

    setTimeout( () => window.scrollTo( { top: 0, left: 0, behavior: 'smooth' } ), 0 );

    localStorage.setItem( 'view', view );

    if ( typeof Munchkin == 'object' )

      Munchkin.munchkinFunction( 'visitWebPage', {
      
        'url': `/clin_us_2025_lab-optimization-consultancy_survey${ window.location.search }#/view/${ view }`

      } );

  }, [ view ] );

  useEffect( () => {

    if ( !answeredAllQuestions && view === 5 ) setView( 1 );
    
    if ( answeredAllQuestions && view !== 5 ) setView( 5 );

  }, [ answeredAllQuestions ] );

  return (

    <ViewContext.Provider value={ { view, updateView: setView } }>

      <Header />

      <Hero />

      <main>

        <div className="mx-auto max-w-4xl pb-12 sm:pb-24 -mt-24 lg:-mt-33">

          <Outlet />

        </div>
        
        { view === 5 && (

          <div className="space-y-12 sm:space-y-24">

            <Share />

            <Disclaimer />

          </div>

        ) }

      </main>

      <Footer />

    </ViewContext.Provider>

  );

}
